export default function Toggle({ value, onChange, label, hint }) {
  return (
    <div className="flex items-start justify-between gap-3">
      <div>
        <div className="font-medium text-white">{label}</div>
        {hint ? <div className="text-sm text-zinc-400 mt-0.5">{hint}</div> : null}
      </div>
      <button
        onClick={() => onChange(!value)}
        className={
          "h-8 w-14 rounded-full ring-1 transition relative inline-flex items-center " +
          (value ? "bg-[#10B981] ring-[#10B981]" : "bg-zinc-800 ring-zinc-700")
        }
        aria-label={label}
      >
        <span
          className={
            "h-6 w-6 rounded-full transition " +
            (value ? "translate-x-7 bg-white" : "translate-x-1 bg-zinc-400")
          }
        />
      </button>
    </div>
  );
}
